import React, { useState, useEffect, useMemo, useRef } from 'react';
import Filter from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/Sizer/NewzooDetailFilter';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { getComputeType, getDefaultTime } from '@/pages/intelligence/utils/topchartsUtils';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import {
  getTopList,
  getMaketsType,
  getCalOtherList,
  getFixedTableData,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/countryUtils';
import {
  statsNewzooTrend,
  statsNewzooMarketTable,
  statsNewzooMarketTrend,
} from '@/pages/intelligence/services/topcharts';
import { connect, getLocale } from 'umi';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { sortTableByMetric, getItemFromArray } from '@/pages/intelligence/utils/tableUtils';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useEarliestTime from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/useEarliestTime';
import { newzooList } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { getCountriesExtendParams } from '@intelligence/utils/filterUtils';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  TopchartPageId,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import {
  DETAIL_PAGEID,
  getDetailPageCfg,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import CombineContent from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/StatsContext';
import { getDefaultPageSortAttr } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_utils';
import {
  getDeviceConfig,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import useChartDownloadHooks from '@/pages/intelligence/pages/TopCharts/_hooks/useChartDownloadHooks';
import { pcconsoleStats } from '@intelligence/v3/constants/downloadLogPoint';
import {
  buildCountriesChartDisplayList,
  buildCountriesTableDisplayList,
  buildCountriesChartRequestParams,
  getCountriesChartRequestMarketList,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_utils/countriesChartOthers';

const NewzooMetrics = (props: any) => {
  const {
    isBasicLoading,
    loading,
    setLoading,
    topchartsState,
    tabType,
    pageId,
    basicInfo,
    gameId,
    appIds,
    regionsCountries,
    isCalibrated,
    entityType,
    isTwoMonths,
    activeSegment,
    mainSegment,
    subSegment,
    gsdDevicesFlatten,
    gsdSegments,
    downloadModalSize = 820,
    // hasDevice,
    filterLeftComp,
    getRadioOptionsTips,
  } = props;

  const metricKey = activeSegment;
  const infoItem = getItemFromArray({
    list: newzooList,
    key: 'value',
    keyVal: metricKey,
  });
  const hasDevice = entityType !== 'pc';
  const { formatMessage } = useIntlExtend(); // 中英切换方法
  const locale = getLocale();
  const deviceDefVales = getDeviceConfig('MAU', entityType)?.value;
  const deviceOptions = getDeviceConfig('MAU', entityType)?.options;
  const pageCfg = getDetailPageCfg(DETAIL_PAGEID.newzoo, tabType, entityType);
  // const [metricSegVal, setMetricSegVal] = useState(pageCfg?.defaultSegmentVal);
  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;

  const isStatsPage = tabType === 'stats';
  const isCountriesPage = tabType === 'countries';
  const marketChartTypeRef = useRef('pie');
  const countryTypeRef = useRef('market');

  const [fetchParams, setFetchParams] = useState({
    date_type: 'month',
    start_date: '',
    end_date: '',
    data_sources: ['newzoo'],
    region_type: 'market',
    regions: ['global'],
    entity_type: entityType,
    metric: [metricKey],
    unified_id: gameId,
    b_group_by_device: defaultByDeviceVal,
    // TODO: 暂时首次调用接口时，加上默认值全选，后续可能需要处理继承逻辑
    device: hasDevice ? deviceDefVales : undefined,
  });

  // const [deviceBtn, setDeviceBtn] = useState(defaultByDeviceVal);
  const [pieData, setPieData] = useState<any[]>([]);
  const [deviceLineData, setDeviceLineData] = useState<any[]>([]);
  const [deviceBarData, setDeviceBarData] = useState<any[]>([]);
  const [devicePieData, setDevicePieData] = useState<any[]>([]);

  const [sumAvgMaxList, setSumAvgMaxList] = useState([]);
  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [trendLoading, setTrendLoading] = useState(loading);
  const [trendChartType, setTrendChartType] = useState<string>(ChartType.Line);
  const [trendChartLoading, setTrendChartLoading] = useState(true);
  const [marketLineData, setMarketLineData] = useState<any>({});
  const [marketTableList, setMarketTableList] = useState<any>([]);
  const [marketChartList, setMarketChartList] = useState<any>([]);
  const [marketLoading, setMarketLoading] = useState(loading);
  const [countryLineLoading, setCountryLineLoading] = useState(true);
  const [marketLineLoading, setMarketLineLoading] = useState(true);
  const [topList, setTopList] = useState<any>(
    /* <TopListProp>*/ {
      total: {},
      global: {},
      globalWoChina: {},
      list: [],
    },
  );
  // 获取下架信息//TODO 从model里拿，存了没
  // const isPullOffGame = topchartsState.islowerGame; //下架的时间
  // const pullOffTime = topchartsState.lowerGameTime; //是否有下架时间的游戏
  // 掉榜游戏展示掉榜提示， 类似Nodata
  // const [isDropdown, setIsDropdown] = useState(false);
  //   trend标题加上数据聚合方式
  const [trendComputeType, setTrendComputeType] = useState('');
  const [trendCount, setTrendCount] = useState('');
  // const [earliestPeriod, setEarliestPeriod] = useState('');
  const [trendError, setTrendError] = useState(false);
  const [marketError, setMarketError] = useState(false);
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const [marketChartType, setMarketChartType] = useState<string>('bar');
  const [marketFixedTableData, setMarketFixedTableData] = useState<any[]>([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [filterLoading, setFilterLoading] = useState(true);
  // 获取计算总数的类型字段
  const [marketType, setMarketType] = useState(
    getMaketsType(fetchParams.regions, fetchParams.regions),
  );

  // 获取可视化下载配置hooks
  const { chartDownloadConfig, setSumList, showDropdownBtnListCur, setTrendsChartDownList } =
    useChartDownloadHooks({
      locale,
      metricValue: activeSegment,
      entityType,
    });

  const {
    earliestPeriod,
    formattedEarliestDay,
    updateEarliestDateData,
    baseReleaseTimeValue,
    baseReleaseTimeData,
  } = useEarliestTime({
    entityType,
    basicInfo,
    appIds,
    dateType: fetchParams.date_type,
    topchartsState,
  });

  useEffect(() => {
    // 是否请求完basic接口
    if (isBasicLoading || filterLoading) {
      // 选择单appid时要重新loading
      setLoading(true);
    } else {
      let newFetchParams = {
        ...fetchParams,
        metric: [metricKey],
      };
      if (isOperateDetail === true) {
        /** 获取继承参数 */
        const extendParams = getExtendParams();
        newFetchParams = { ...newFetchParams, ...extendParams };
      }
      getPageData(newFetchParams);

      updateEarliestDateData({
        dataSources: newFetchParams.data_sources,
        metrics: [metricKey],
        regionType: fetchParams.region_type,
        regions: fetchParams.regions,
        dateType: fetchParams.date_type,
      });
    }
  }, [isBasicLoading, pageId, filterLoading]);

  const getPageData = (newFetchParams: any) => {
    if (isStatsPage) {
      getStatsData(newFetchParams);
    } else if (isCountriesPage) {
      getCountry(newFetchParams, countryTypeRef.current);
    } else {
      console.error(`tabType=${tabType} is not stats||countries!`);
    }
  };

  const formatRegionParams = (markets: string[]) => {
    // 保存的方案选择后可特殊处理国家值为交集之后的值
    const { regionValues, filterExtendValue } = getCountriesExtendParams({
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      markets,
      filterExtend: detailFilterExtend,
    });
    setDetailFilterExtend(filterExtendValue);
    return regionValues?.regions;
  };

  const getExtendParams = () => {
    const newFetchParams: any = {};
    // 如果是月粒度就继承
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    const marketExtend = detailFilterExtend[filterKeyMap.REGION];
    if (timeExtend?.granularity === 'monthly') {
      // 如果是月粒度才继承
      newFetchParams.date_type = 'month';
      newFetchParams.start_date = timeExtend?.start_date || '';
      newFetchParams.end_date = timeExtend?.end_date || '';
    }
    newFetchParams.region_type = 'market';
    newFetchParams.regions = formatRegionParams(marketExtend?.markets);
    return newFetchParams;
  };

  const buildNewzooCountriesRequestParams = (params: any) => {
    return buildCountriesChartRequestParams(params);
  };

  const getStatsData = async (params = fetchParams) => {
    const newFetchParams = { ...fetchParams, ...params };
    /**
     * 无 regions 字段时指定 regions 默认值，避免接口报错
     * 1. globalOnly 时表单无 region 字段，指定默认值
     * 2. 从 globalOnly 指标切回普通指标，修改时间，也暂时获取不到 regions 值
     */
    if (!newFetchParams.regions?.length) {
      newFetchParams.regions = ['global'];
    }

    setFetchParams(newFetchParams);
    try {
      /** 接口速率优化：
       * 第一次时间为空时先请求trend获取时间后再请求channel；
       * 如果时间不为空，则可以同时请求2个接口
       */
      const { start_date = '', end_date = '' } = await getTrends(newFetchParams);

      if (start_date && end_date) {
        newFetchParams.start_date = start_date;
        newFetchParams.end_date = end_date;
      } else {
        const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
        newFetchParams.start_date = defautStart;
        newFetchParams.end_date = defautEnd;
      }
      setFetchParams(newFetchParams);
    } catch (err) {
      console.error(err);
      setTrendLoading(false);
    }
  };

  const getTrends = async (params: any) => {
    setTrendLoading(true);
    setLoading(true);
    const newFetchParams = { ...fetchParams, ...params };
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });
    try {
      const trendRes = await statsNewzooTrend(newFetchParams);
      setTrendComputeType(getComputeType(trendRes?.data?.aggregation));
      const avgValue = trendRes?.data?.aggregation_value;
      if (
        infoItem?.renderType === RenderType.GROWTH_ONLY ||
        infoItem?.renderType === RenderType.GROWTH_AND_RATIO
      ) {
        const growthDataObj = growthFormat({
          value: avgValue,
          valueType: 'pointValue',
          hasPoint: 'all',
          fixedNum: 2,
          maxNumber: 99999,
        });
        setTrendCount(avgValue === null ? '-' : growthDataObj.value);
      } else {
        setTrendCount(valueFormat(avgValue, false, 0));
      }

      const startDate = trendRes?.req?.start_date;
      const endDate = trendRes?.req?.end_date;
      const reqApi = {
        ...newFetchParams,
        start_date: startDate,
        end_date: endDate,
      };
      // setIsDropdown(trendRes?.data?.b_drop_global || false);
      setFetchParams({ ...reqApi });

      const sumAvgList = trendRes?.data?.sum_avg || [];
      // 如果是需要提供可视化下载的metirc，需要调用此hooks方法，提供对应config数据
      if (Array.isArray(sumAvgList) && sumAvgList?.length > 0) {
        setSumList(sumAvgList);
      }

      setTrendLineList(trendRes?.data?.trends || []);
      setTrendsChartDownList(trendRes?.data?.trends || []);
      setTrendTableList(trendRes?.data?.trends || []);
      if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
        setSumAvgMaxList(trendRes?.data?.sum_avg || []);
        setPieData(trendRes?.data?.total || []);
      } else {
        setPieData([]);
      }
      setDeviceLineData(trendRes?.data?.device_trends || []);
      setDevicePieData(trendRes?.data?.device_pie);

      // 给时间筛选器赋值
      // setDateTimeDatas('month', startDate, endDate);
      setTrendLoading(false);
      setLoading(false);
      setTrendError(false);
      // return {
      //   start_date: startDate,
      //   end_date: endDate,
      // };
    } catch (err) {
      setSumAvgMaxList([]);
      setTrendLineList([]);
      setTrendTableList([]);
      setDevicePieData([]);
      setPieData([]);
      // setDateTimeDatas('month', '', '');
      setTrendLoading(false);
      setLoading(false);
      setTrendError(true);
      // return {
      //   start_date: '',
      //   end_date: '',
      // };
    }
  };

  const getCountry = async (params: any /* , countryType: string*/) => {
    let newFetchParams = {
      ...fetchParams,
      ...params,
      // region_type_share: countryType,
    };
    newFetchParams.app_ids = appIds;
    newFetchParams = {
      ...newFetchParams,
      regions: newFetchParams?.regions || ['global'],
    };
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });
    setLoading(true);
    setMarketLoading(true);
    const marketType = getMaketsType(newFetchParams.regions, newFetchParams.regions);
    setMarketType(marketType);
    try {
      const countryRes = await statsNewzooMarketTable(
        buildNewzooCountriesRequestParams(newFetchParams),
      );
      let startDate = '';
      let endDate = '';

      if (countryRes?.code === 0 && !!countryRes?.data) {
        // const totalList = countryRes?.data?.metrics_total || [];
        const tableList = countryRes?.data?.market_aggregated || [];

        const sortData = sortTableByMetric({
          tableData: tableList,
          sortParams: {
            ratioType: 0,
            sortVal: 'desc',
            sortMetric: metricKey,
          },
          metricProperty: 'name',
          growthProperty: 'dod',
        });
        // tableList.unshift(totalList ? totalList || {} : {})
        const topListTmp = getTopList(sortData);

        // fix 没数据时不给firstFixedData赋值，不然会多出global等
        const firstFixedData = !tableList.length ? [] : getFixedTableData(marketType, topListTmp);
        setTopList(topListTmp);
        setMarketFixedTableData(firstFixedData);

        setMarketTableList(buildCountriesTableDisplayList(topListTmp.list));
        // 获取图表展示国家来请求折线图，
        // 返回表格的数据中的国家只有一个并且为Global时，则把Global传给后端 ， 并且展示一条数据（无Hoversort)
        let lineTopMarket = [];
        let chartsMarket: any = [];

        if (infoItem?.globalOnly || (tableList?.length === 1 && tableList[0].market === 'global')) {
          lineTopMarket = ['global'];
          chartsMarket = tableList;
          // setMarketTableList(tableList);
        } else if (topListTmp.list?.length > 0) {
          chartsMarket = buildCountriesChartDisplayList(topListTmp.list);
          lineTopMarket = getCountriesChartRequestMarketList(topListTmp.list);
        }

        setMarketChartList(chartsMarket);
        const allCountryList = countryRes?.data?.device_list || [];
        const arrTemp: any = [];
        chartsMarket?.forEach((item: any) => {
          allCountryList?.forEach((subItem: any) => {
            if (item.market === subItem.market) {
              arrTemp.push(subItem);
            }
          });
        });
        // 添加柱状Device堆叠数据
        setDeviceBarData(arrTemp);
        // setDeviceBarData(countryRes?.data?.device_list);

        startDate = countryRes?.req?.start_date;
        endDate = countryRes?.req?.end_date;
        if (startDate && endDate) {
          newFetchParams.start_date = startDate;
          newFetchParams.end_date = endDate;
        } else {
          const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
          newFetchParams.start_date = defautStart;
          newFetchParams.end_date = defautEnd;
        }
        setFetchParams(newFetchParams);
        // setMarketTotalList(totalList || []);
        if (marketChartTypeRef.current === 'line' || marketChartTypeRef.current === 'stackedLine') {
          // 有数据的情况下，才调用折线图接口
          if (Array.isArray(lineTopMarket) && lineTopMarket?.length > 0) {
            getCountryTrends(
              buildNewzooCountriesRequestParams(
                {
                  ...newFetchParams,
                  /** 后端获取图表国家或地区，用regiontype区分国家或地区，regeions传国家或地区 */
                  // region_type: countryType,
                  // country_trend_markets: topMarketsRegions,
                  country_trend_markets: lineTopMarket,
                },
              ),
            );
          }
        }
      } else {
        setMarketLineData([]);
        setMarketTableList([]);
        setMarketChartList([]);
      }
      setMarketError(false);
    } catch (err) {
      console.error(err);
      setMarketLineData([]);
      setMarketTableList([]);
      setMarketChartList([]);
      setMarketError(true);
    }
    setMarketLoading(false);
    setLoading(false);
  };

  // 添加topList的传入，防止异步
  const getCountryTrends = async (params: any) => {
    // console.log('getCountryTrends', params);
    setCountryLineLoading(true);
    setMarketLineLoading(true);
    try {
      // 首次请求后就把折线图数据存起来， 点折线图图片就直接取； 只有改变筛选器时才重新请求
      const res = await statsNewzooMarketTrend(params);
      // 折线图已有新的
      // 重组lineData , 将name 和 cover赋值给lineData
      // 组装数据为rpd一样
      const lineDataRes = res?.data?.market_time || [];
      setMarketLineData(buildCountriesChartDisplayList(lineDataRes));
      // setEarliestCountry(country);
    } catch (err) {
      setMarketLineData([]);
    }
    setCountryLineLoading(false);
    setMarketLineLoading(false);
  };

  const handleConfirm = (value: any) => {
    const newFetchParams = { ...fetchParams, ...value };
    // 获取页面接口
    getPageData(newFetchParams);
  };

  const changeMarketChartType = (value: string) => {
    setMarketChartType(value);
    marketChartTypeRef.current = value;
    if (value === 'line' || value === 'stackedLine') {
      let topMarketsRegions = getCountriesChartRequestMarketList(topList.list);

      if (
        infoItem?.globalOnly ||
        (marketTableList?.length === 1 && marketTableList[0].market === 'global')
      ) {
        topMarketsRegions = ['global'];
      }

      getCountryTrends(
        buildNewzooCountriesRequestParams(
          {
            ...fetchParams,
            // region_type: fetchParams.region_type_share,
            country_trend_markets: topMarketsRegions,
          },
        ),
      );
    }
  };

  const getDownloadFetchParams = () => {
    let paramsTmp: {
      [key: string]: any;
    } = {
      ...fetchParams,
      segment: pageId,
      unified_id: gameId,
      unified_ids: [gameId],
      currentMetric: ['revenue'].includes(mainSegment) ? subSegment : mainSegment,
      subSegment,
      // region_type: "region",
      // regionType: "region",
      // regions: ['global'],
      isCountriesPage,
    };
    if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
      paramsTmp = {
        ...paramsTmp,
        source: paramsTmp?.data_sources?.[0] || '',
        sort_field: paramsTmp?.metric?.[0] || '',
      };
    }
    return paramsTmp;
  };

  const onFilterInit = (params: any) => {
    const { loading, regionOptions } = params || {};
    setFilterLoading(loading);
    setRegionOptions(regionOptions);
  };

  const getCardStatus = () => {
    if (isCountriesPage) {
      return {
        isLoading: loading || marketLoading,
        isError: marketError,
        isNoData: !marketTableList?.length && !marketFixedTableData?.length,
      };
    }
    const isAllEmptyData = trendTableList?.every((item: any) => item?.metrics === null);
    return {
      isLoading: loading || trendLoading,
      isError: trendError,
      isNoData: !trendTableList?.length || isAllEmptyData,
    };
  };
  const segmentTitle = formatMessage({
    id: /* infoItem?.textDetail ??*/ infoItem?.text,
  });
  const pageSortAttr = getDefaultPageSortAttr(isStatsPage, 'desc', metricKey);

  const ifUseMarketLineLoading = useMemo(() => {
    let ifUseTemp = false;
    if (isCountriesPage && (marketChartType === 'line' || marketChartType === 'stackedLine')) {
      ifUseTemp = true;
    }
    return ifUseTemp;
  }, [isCountriesPage, marketChartType]);
  let showCountriesChartItemNum: number | undefined;
  if (isCountriesPage) {
    showCountriesChartItemNum = Number.MAX_SAFE_INTEGER;
  }

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          {filterLeftComp}
          <Filter
            onFilterInit={onFilterInit}
            timeFilterValues={{
              type: fetchParams.date_type,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            isCalibrated={isCalibrated}
            buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterInit={() => {}}
            globalOnly={infoItem?.globalOnly}
            entityType={entityType}
            basicInfo={basicInfo}
            appIds={appIds}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
            hasDevice={hasDevice}
            deviceDefVales={deviceDefVales}
            deviceOptions={deviceOptions}
            getRadioOptionsTips={getRadioOptionsTips}
          />
          {infoItem?.globalOnly && (
            <span className="dbi-statsfilter-warp-left-text">
              {formatMessage({ id: 'dbi_global_only' })}
            </span>
          )}
        </div>
        <div className="dbi-statsfilter-warp-right">
          <ExportTable
            entityType={entityType}
            tableParams={getDownloadFetchParams()}
            businessType={`${entityType}-stats-countries`}
            isDisableDownload={loading}
            isShowMaxDownloadRowsTips={false}
            downloadModalSize={downloadModalSize}
            isDisableDataAmount={true}
            newStyleFileName={`${basicInfo?.name}${
              isStatsPage ? '_Stats' : isCountriesPage ? '_Countries' : ''
            }`}
            pageId={
              entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE
                ? TopchartPageId.PCConsoleMetricsTable
                : undefined
            }
            gsdDevicesFlatten={gsdDevicesFlatten}
            gsdSegments={gsdSegments}
            showDropdownBtnList={
              isStatsPage && (trendChartType === 'line' || trendChartType === 'stackedLine')
                ? showDropdownBtnListCur
                : false
            }
            chartDownloadConfig={chartDownloadConfig}
            tabType={tabType}
            downloadLogConfigKey={pcconsoleStats?.[`${entityType}_${tabType}_${mainSegment}`]}
          />
        </div>
      </div>
      <CombineContent
        pageId={pageId}
        entityType={entityType}
        isCountriesPage={isCountriesPage}
        fixedTableData={marketFixedTableData}
        tableData={isCountriesPage ? marketTableList : trendTableList}
        sumAvgMaxList={sumAvgMaxList}
        lineData={isCountriesPage ? marketLineData : trendLineList}
        barData={isCountriesPage ? marketChartList : []}
        pieData={isCountriesPage ? marketChartList : pieData}
        stackBarData={deviceBarData}
        stackLineData={deviceLineData}
        stackPieData={devicePieData}
        calOtherList={getCalOtherList(marketType, topList)}
        chartType={isCountriesPage ? marketChartType : trendChartType}
        setChartType={isCountriesPage ? changeMarketChartType : setTrendChartType}
        metricSegVal={subSegment}
        setMetricSegVal={() => {}}
        cardStatus={getCardStatus(tabType)}
        earliestDay={formattedEarliestDay}
        baseReleaseTime={baseReleaseTimeData}
        firstWeekReleaseTime={baseReleaseTimeValue}
        earliestPeriod={earliestPeriod}
        defaultByDeviceVal={defaultByDeviceVal}
        dateType={fetchParams.date_type}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        pageSortAttr={pageSortAttr}
        pageCfg={{
          ...pageCfg,
          // countries可视化三视图根据指标变化
          disableChartType: isStatsPage
            ? pageCfg?.disableChartType
            : infoItem?.globalOnly
              ? [ChartType.Pie]
              : [],
          tableMetricList: [infoItem],
        }}
        cardTitle={
          isStatsPage
            ? `${segmentTitle}${locale === 'zh-CN' ? '' : ' '}${formatMessage({
              id: `dbi_detail_trend`,
            })}`
            : ''
        }
        subTitle={
          entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE && isStatsPage
            ? `${trendComputeType} ${segmentTitle} : ${trendCount}`
            : ''
        }
        chartLoading={isCountriesPage ? countryLineLoading : trendChartLoading}
        setChartLoading={isCountriesPage ? setCountryLineLoading : setTrendChartLoading}
        marketLineLoading={marketLineLoading}
        ifUseMarketLineLoading={ifUseMarketLineLoading}
        visualisMetric={metricKey}
        visualisTitleNow={formatMessage({
          id: /* infoItem?.textDetail ??*/ infoItem?.text,
        })}
        gameName={basicInfo?.name}
        gameCover={basicInfo?.cover}
        changeDeviceBtn={() => {}}
        regionsCountries={regionsCountries || []}
        isPercentage={infoItem?.renderType === RenderType.GROWTH_ONLY}
        mainSegment={mainSegment}
        ifLineChartLegendOn={showDropdownBtnListCur}
        stackLineTooltipShowAll={marketChartType === 'stackedLine'}
        showChartsItemNum={showCountriesChartItemNum}
      />
    </>
  );
};

export default connect((state: any) => ({
  filterState: state[FILTER_EXTEND_NAMESPACE],
  topchartsState: state[DBI_TOPCHARTS],
}))(NewzooMetrics);
